import logo from "../../../../public/projects/Kolte/images/logo/logo.png"
import canvas from "../../../../public/projects/Kolte/images/projects/canvas.jpg"
// kolte_canvas
import overviewImage_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Overview/1.webp";
import bannerDesktopImage_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Banner/1.webp";
import bannerMobileImage_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Banner/2.webp";
import siteVisitBannerImage_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/SiteVisitBanner/1.webp";
import Location_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Location/L1.webp";
import Hightlights_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Highlights/1.webp";
import floorplan1_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/floorplan/1.webp";
import floorplan2_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/floorplan/2.webp";
// import floorplan3_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/floorplan/3.webp";
// import floorplan4_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/floorplan/4.webp";
// import floorplan5_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/floorplan/5.webp";
import locationicon_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Overview/l.png";
import calicon_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Overview/c.png";
import newlaunchicon_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Overview/n.png";
// import loc from "./images/Overview/loc.png"
import gallery1_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Gallery/1.webp";
import gallery2_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Gallery/2.webp";
import gallery3_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Gallery/3.webp";
import gallery4_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Gallery/4.webp";
import gallery5_kolte_canvas from "../../../../public/projects/Kolte/images/canvas/Gallery/5.webp";
export const developerKolte = {
  
  properties: [
    {
      name: "Kolte Canvas",
      image:canvas,
      price: "On Request",
      state:"Pune",
      developer:"Kolte",
      projectlocation:"West Pune",
      location: "Hinjawadi, Pune",
      bed: "3 - 4 BHK ",
      size: "1151 - 2012 Sq.ft.",
      url: `/koltepatil-canvas-hinjewadi-pune`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    }, 
  ],
};
export const Headers = {
  logo: logo,
  data: {
    experience: "1991",
  },
  about: `One real estate firm that is well-known in the Pune residential sector is Kolte-Patil Developers. It was established with the motto "Creation, not construction" almost thirty years ago. With a saleable area of almost 20 million square feet, the company has developed more than 50 projects in Bengaluru, Mumbai, and Pune, including IT parks and residential and commercial complexes. 
`,
};
export const projectsKolteCanvas = {
  kolte_canvas: {
    bannerdata: {
      bannerDesktopImage:bannerDesktopImage_kolte_canvas,
      bannerMobileImage:bannerMobileImage_kolte_canvas,
      textOverlay: "",
      data: {
        title: "Kolte  Canvas",
        subtitle: "Hinjawadi, Pune",
        starting_price: "On Request",
        payment_plan: "CLP",
        rerano:"P52100032428",
        status: "Under Construction"
      }
    },
    overview: {
      heading: "Discover Luxury Living at Kolte Canvas",
      description: [
        "Kolte Canvas in Hinjawadi, Pune West, is an upcoming under-construction housing society by Kolte Patil, set for possession in December 2029. Offering modern apartments for sale, this project is designed to meet the needs of homebuyers with essential facilities and amenities. Nestled in a prime location, Kolte Canvas promises a comfortable and convenient lifestyle.",
        " Whether for investment or personal living, this development ensures a blend of quality and contemporary living. With thoughtfully planned infrastructure and modern conveniences, it presents a great opportunity for those looking to own a home in one of Pune’s growing residential hubs.",
      ],
      image: overviewImage_kolte_canvas,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicon_kolte_canvas,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicon_kolte_canvas,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicon_kolte_canvas,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_kolte_canvas,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "1151 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK ",
          area: "1700 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
          area: "1151 sq. ft.",
          price: "On Request*",
        image: floorplan1_kolte_canvas,
      },
      {
        type: "4 BHK ",
          area: "1700 sq. ft.",
          price: "On Request*",
        image: floorplan2_kolte_canvas,
      },
      
    ],

    highlights: {
      images: Hightlights_kolte_canvas,
      tagline: "Highlights",
      features: [
        "There are around 454 Units on offer.",
        "Kolte Canvas Hinjewadi housing society has 4 Towers with 35 Floors.",
        "Kolte Canvas Pune West has some great amenities to offer such as Gymnasium, Club House and Creche/Day Care.",
        "Property prices in locality has changed 13.0% in one year",
        "The project is spread over an area of 6.24 acres.",
        "One Stop Destination For Live- Work And Play.",

      ],
    },

    location: {
      image: Location_kolte_canvas,
      data:[
        {
          airport:{
            distance_time:"23 km",
            name:"Pune Airport"
          },
          school:{
            distance_time:"4 Km",
            name:"SCMHRD"
          },
          railwayormetro:{
            distance_time:"5 Km",
            name:"Hinjewadi"
          },
          hospital:{
            distance_time:"3 Km",
            name:"Sanjeevani"
          },
          mall:{
            distance_time:"2 Km",
            name:"Entertainment Hubs"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1_kolte_canvas },
        { image: gallery2_kolte_canvas },
        { image: gallery3_kolte_canvas },
        { image: gallery4_kolte_canvas },
        { image: gallery5_kolte_canvas },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Kolte Canvas, kindly share more details.",
    },

    faq: [
      
      {
        question: "Where is Canvas located?",
        answer: `Canvas is situated in the Life Republic township near Hinjewadi, Pune, close to major IT hubs and essential amenities.`,
      },
      {
        question: "What are the available apartment configurations?",
        answer: `The project offers 3 BHK apartments ranging from 1,330 to 1,500 sq. ft. and 4 BHK apartments starting from 1,700 sq. ft`,
      },
      {
        question: "What are the standout features of the apartments?",
        answer: `Each unit includes two master suites, walk-in wardrobe spaces, floor-to-ceiling windows for ample natural light, and a 25 to 32 feet long viewing deck.`,
      },
      {
        question: "What makes Kolte Canvas a standout choice for homebuyers?",
        answer: `Kolte Canvas stands out as an exceptional choice for homebuyers due to its modern design, premium amenities, and strategic location.`,
      },
      {
        question: "Are there any unique amenities?",
        answer: `Yes, Canvas boasts a sky bridge at the terrace level (~120m height), a 38-meter long infinity edge lap swimming pool, and a 2-acre Tetris-themed landscape with over 20 podium amenities.`,
      },
      {
        question: "What recreational facilities are available?",
        answer: `Residents can enjoy a fitness plaza, yoga and Zumba areas, indoor games, a media room, dance hall, music room, and more.`,
      },
      {
        question: "Are there sports facilities on the premises?",
        answer: `Yes, the project includes courts for padel tennis, pickleball, basketball, badminton, squash, a skating rink, and a cricket practice net.`,
      },
      {
        question: "Is there provision for children and pets?",
        answer: `Canvas offers a dedicated kids' play area, creche, and a pet park to cater to families with children and pets.`,
      },
      {
        question: "What sustainability features are incorporated",
        answer: `The project emphasizes green building practices, including landscaped gardens, tree-lined avenues, rainwater harvesting systems, and energy-efficient fixtures.`,
      },
      {
        question: "How is the connectivity to major areas?",
        answer: `Canvas is well-connected to major highways, including the Mumbai-Pune Expressway, and is in close proximity to the Hinjewadi IT Park, ensuring seamless travel to work and other city areas.`,
      },
    ],
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
}
